[
  {
    "text": "A man who conquers himself is greater than one who conquers a thousand men in battle.",
    "author": "Buddha"
  },
  {
    "text": "The successful man is the average man, with laser-like focus.",
    "author": "Bruce Lee"
  },
  {
    "text": "Try not to become a man of success, but rather try to become a man of value.",
    "author": "Albert Einstein"
  },
  {
    "text": "A strong man stands up for himself. A stronger man stands up for others.",
    "author": "Ben on the Barnyard"
  },
  {
    "text": "Waste no more time arguing about what a good man should be. Be one.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "The mark of a great man is one who knows when to set aside the important things in order to accomplish the vital ones.",
    "author": "Brandon Sanderson"
  },
  {
    "text": "Hard times create strong men, strong men create good times, good times create weak men, and weak men create hard times.",
    "author": "G. Michael Hopf"
  },
  {
    "text": "It is not what a man has, but what a man is, that matters.",
    "author": "Oscar Wilde"
  },
  {
    "text": "A superior man is modest in his speech, but exceeds in his actions.",
    "author": "Confucius"
  },
  {
    "text": "The measure of a man is what he does with power.",
    "author": "Plato"
  },
  {
    "text": "No man is more unhappy than he who never faces adversity. For he is not permitted to prove himself.",
    "author": "Seneca"
  },
  {
    "text": "A man's true wealth is the good he does in this world.",
    "author": "Prophet Muhammad"
  },
  {
    "text": "He who is brave is free.",
    "author": "Seneca"
  },
  {
    "text": "Man cannot remake himself without suffering, for he is both the marble and the sculptor.",
    "author": "Alexis Carrel"
  },
  {
    "text": "The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively.",
    "author": "Bob Marley"
  },
  {
    "text": "A real man loves his wife, and places his family as the most important thing in life.",
    "author": "Frank Abagnale"
  },
  {
    "text": "There is nothing noble in being superior to your fellow man; true nobility is being superior to your former self.",
    "author": "Ernest Hemingway"
  },
  {
    "text": "A good man would prefer to be defeated than to defeat injustice by evil means.",
    "author": "Sallust"
  },
  {
    "text": "The first step to be a good man is this: You must deeply feel the burden of the stones some else is carrying.",
    "author": "Mehmet Murat ildan"
  },
  {
    "text": "To have become a deeper man is the privilege of those who have suffered.",
    "author": "Oscar Wilde"
  }
]